import { Link } from 'react-router-dom';
import * as links from '../../utils/general_links';
import NavBar from './NavBar';
import logo from '../../assets/logo_presentis.png';

function Header() {
	return (
        <header>
            <NavBar />
            <div id='header' style={{backgroundColor: 'white', marginBottom: '12px', height: '86px'}}>
                <div style={{maxWidth: '980px', margin: 'auto'}}>
                    <div style={{width: '221px', cursor: 'pointer'}}>
                        <Link to={ links.ROUTES.home }>
                            <img src={ logo } alt="logo PRESENTIS" />
                        </Link>
                    </div>
                </div>
            </div>
        </header>
	);
};

export default Header;